import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import type React from 'react';

import { darkTheme, lightTheme } from './theme';
import { useThemeStore } from '@/stores/use-theme-store';

interface AppThemeProviderProps {
    children: React.ReactNode;
}

/**
 * Application theme provider with dark mode support
 */
export function AppThemeProvider({ children }: AppThemeProviderProps): React.JSX.Element {
    const { mode } = useThemeStore();
    const theme = mode === 'dark' ? darkTheme : lightTheme;

    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    );
}

export default AppThemeProvider;
